import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../components/data/logo.png";
import { Box } from "@mui/material";



// This component renders the header that appears on all pages

const PageHeader = () => {
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState(''); // Checks whether an incorrect email has been submitted. If yes, display an error message.
  const [subscribedStatus, setSubscribedStatus] = useState(false);

  // Calls necessary functionsi when user presses "enter" 
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      event.stopPropagation();  // This prevents the event from bubbling up so that next point isn't called
      sendEmail();
    }
  };

  // Handles what happens when users submit an email
  const sendEmail = async () => {
    // Clear any existing errors
    setEmailError('');
    if (email.trim() !== "") {
      // Email validation regex pattern
      const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (!emailRegex.test(email)) {
        // Show a message to the right of the email input field 
        setEmailError('Invalid email'); // Set the error message
        return;
      } else {
        // Email was inputted correctly
        setSubscribedStatus(true); // Causes a re-render to show'thank you for subscribing'
      }

      await storeUserEmail(email); // Write email to db

      // Clear the message input
      setEmail('');
    }
  };


  // Calls API to store user email in the API. We already validate the email in the front end
  // before passing it in here
  const storeUserEmail = async (event) => {
    try {
      const response = await fetch('https://versify-back-b066d2bc73d1.herokuapp.com/signupwithout', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        // console.log('Signup successful! User ID: ' + data.userId);
      } else {
        // If we receive an error from the server
        // console.log(data.error || 'Signup failed');
      }
    } catch (error) {
      // If there is an error during fetch, such as no network connection
      // console.log('Network error: Could not connect to the server');
    }
  };

  return (
    <Box className="headerContainer">

      <img
        className="headerPhoto"
        id="logoPhoto"
        src={logo}
        alt="Blog Logo"
      />

      <Link to="/" className="logoText">
        Versify
      </Link>


      {!subscribedStatus ? (  // Check if subscribedStatus is false
        <div className="custom-search" style={{
          position: 'absolute',
          right: '11%',
        }}>
          <>
            <input type="email" className="custom-search-input"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)} // Update the state as the user types
              onKeyDown={handleKeyPress}
            />
            <button className="custom-search-botton" type="submit" onClick={sendEmail}
            >Join Versify Waitlist</button>

            {/* Displays an error message */}
            {emailError && <span className="email-error-message">{emailError}</span>}
          </>

        </div>) :
        <div className="thankYouMessage"
          style={{
            position: 'absolute',
            right: '11%',
          }}> Thank you for subscribing! </div>}


    </Box>
  );
};

export default PageHeader;
